import React from 'react';
import { formatNumber, formatCurrency, ESTIMATE_YEARS } from '../../../helpers';
import { data } from '../../../data';
import './index.scss';
import { getText } from '../../../copies';

interface RankingListProps {
  cities: ((typeof data.cities)[0] & { orderBy: number })[];
  categorySorting: typeof data.sorting.category;
  activeSorting: {
    year: number;
    speciality: string;
    category: string;
  };
  sortingChangeHandler: (type: string, value: number | string) => void;
  showCityView: (index: number) => void;
}

const RankingList: React.FC<RankingListProps> = ({
  cities,
  categorySorting,
  activeSorting,
  sortingChangeHandler,
  showCityView,
}) => {
  const changeSorting = (e) => {
    const { name, value } = e.target;

    sortingChangeHandler(name, value);
  };

  return (
    <div className="ranking-list">
      <div className="sorting">
        <label>{getText('ranked_by')}</label>
        <select name="category" value={activeSorting.category} onChange={changeSorting}>
          {categorySorting.map((category) => (
            <option key={`dropdown-category-option-${category.value}`} value={category.value}>
              {category.title}
            </option>
          ))}
        </select>
      </div>
      <ul>
        {cities.map((city, index) => (
          <li key={`list-item-${city.id}`}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                showCityView(index);
              }}
            >
              #{index + 1} {city.short_name}
            </a>
            <span>
              {activeSorting.category === 'revenue' ? formatCurrency(city.orderBy) : formatNumber(city.orderBy)}
            </span>
          </li>
        ))}
      </ul>
      <p>{getText('info_title_projections', { years: ESTIMATE_YEARS.join(', ') })}</p>
    </div>
  );
};

export default RankingList;
